import type { ReactNode } from "react";
import React from "react";
import { Component } from "react";
import type { ClosePopupThunkType } from "src/shared/popups/actions/PopupActionCreators";
import { ClosePopup } from "src/shared/popups/actions/PopupActionCreators";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import type Popup from "src/shared/popups/objects/Popup";

interface IPopupsInnerProps extends IPopupsProps {
  popups: Popup[];
}
class PopupsInner extends Component<IPopupsInnerProps> {
  public render(): ReactNode {
    const { popups } = this.props;
    if (popups.length <= 0) {
      return null;
    }

    return (
      <>
        {popups.map((popup, index) =>
          React.createElement(popup.PopupClass, {
            ...popup.PopupProps,
            key: index,
            ClosePopup: (result?: any) => {
              popup.resolve(result);
              this.props.ClosePopup(popup);
            },
            AbortPopup: (ex: any) => {
              popup.reject(ex);
              this.props.ClosePopup(popup);
            },
          }),
        )}
      </>
    );
  }
}

export interface IPopupsProps {
  ClosePopup: ClosePopupThunkType;
}
export default connect(
  (state) => {
    return {
      popups: state.popups.popups,
    };
  },
  (dispatch) =>
    bindActionCreators(
      {
        ClosePopup,
      },
      dispatch,
    ),
)(PopupsInner);
